import styled from 'styled-components';

import { basicTitleTextStyle, colorsMatrix, StyledFlex } from '@dreryk/react-components';

export const StyledModuleChip = styled(StyledFlex)`
   ${basicTitleTextStyle};
   padding: 8px 12px 8px 15px;
   background-color: ${colorsMatrix.turkus.basic};
   color: ${colorsMatrix.grey.lightest};
   border-radius: 20px;
`;
